import styles from "./ScreenCopy.module.css";

interface ScreenCopyProps {
  headline: string;
  subline?: string;
  /** Fades the copy out, before it is swapped for the next one. */
  leaving?: boolean;
}

/**
 * Matches the word "spark", plus a full stop right after it, so the headline can show
 * them in the spark's colour.
 */
const SPARK_WORD = /\b(spark\.?)(?!\w)/i;

function highlightSpark(text: string) {
  // split() with a capture group keeps the matches at the odd indices.
  return text.split(SPARK_WORD).map((part, i) =>
    i % 2 === 1 ? (
      <span key={i} className={styles.spark}>
        {part}
      </span>
    ) : (
      part
    ),
  );
}

/**
 * Headline and optional subline shared by the screens; fades in, staggered, whenever it
 * is remounted.
 */
export function ScreenCopy({ headline, subline, leaving = false }: ScreenCopyProps) {
  return (
    <div className={leaving ? `${styles.copy} ${styles.leaving}` : styles.copy}>
      <h1>{highlightSpark(headline)}</h1>
      {subline ? <p>{subline}</p> : null}
    </div>
  );
}
